import { render, staticRenderFns } from "./edition2.vue?vue&type=template&id=6847e222"
import script from "./edition2.vue?vue&type=script&lang=js"
export * from "./edition2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports